var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-app", [
    _c("div", { attrs: { id: "settings" } }, [
      _c("div", { staticClass: "container-1800" }, [
        _c(
          "div",
          { staticClass: "content ml-auto mr-auto" },
          [
            _c(
              "header",
              { staticClass: "d-flex justify-content-between align-center" },
              [_c("h1", [_vm._v(_vm._s(_vm.$t("pages.settings.title")))])]
            ),
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { name: "branding", lazy: "" } },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-uppercase",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("pages.settings.tabs.branding")) +
                            " "
                        ),
                      ]
                    ),
                    _c("branding-tab"),
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  { attrs: { name: "users", lazy: "" } },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-uppercase",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("pages.settings.tabs.users")) +
                            " "
                        ),
                      ]
                    ),
                    _c("users-tab"),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }